<form class="p-3" #OtpForm="ngForm">
<div class="d-flex justify-content-end align-items-center">
    <app-svg-icon [name]="'cross'" class="cross-button" (click)="activeModal.dismiss()"></app-svg-icon>
</div>
    <div class="col-12 py-3 px-5">
        <div class="d-flex justify-content-center">
            <label class="f-13 font-semibold text-primary-color mb-0" for="">OTP Verification</label>
        </div>
        <div class="row">
            <div class="col-2">
                <app-input  [isOtpInput]="otp1" [onlyNumbers]="true"
                    [isOnPaste]="true" (onPaste)="onPaste($event)" onlyNumbers [inputName]="'opt1'" [inputType]="'text'" [inputId]="'opt1Id'"
                    [inputValue]="otp1" (inputValueEmit)=" otp1 = $event" [isRequired]="true" [maxLength]="1"
                    [focusInputOtp]="true" (keyup)="moveFocusToSecondInput($event,'opt2Id','opt1Id')"
                    [inputClass]="'text-center'" [ngClass]="{'border-red': (!otp1 && OtpForm?.form?.controls?.opt1?.touched)}">
                </app-input>
            </div>
            <div class="col-2">
                <app-input [onlyNumbers]="true" [isOtpInput]="otp2" [isOnPaste]="true" (onPaste)="onPaste($event)" onlyNumbers [inputName]="'opt2'" [inputType]="'text'" [inputId]="'opt2Id'"
                    [inputValue]="otp2" [maxLength]="1" (inputValueEmit)="otp2 = $event" [isRequired]="true"
                    [focusInputOtp]="true" (keyup)="moveFocusToSecondInput($event,'opt3Id','opt1Id')"
                    [inputClass]="'text-center'" [ngClass]="{'border-red': (!otp2 && OtpForm?.form?.controls?.otp2?.touched)}">
                </app-input>
            </div>
            <div class="col-2">
                <app-input [onlyNumbers]="true" [isOtpInput]="otp3" [isOnPaste]="true" (onPaste)="onPaste($event)" onlyNumbers [inputName]="'opt3'" [inputType]="'text'" [inputId]="'opt3Id'"
                    [inputValue]="otp3" [maxLength]="1" (inputValueEmit)="otp3 = $event" [isRequired]="true"
                    [inputClass]="'text-center'" [focusInputOtp]="true"
                    (keyup)="moveFocusToSecondInput($event,'opt4Id','opt2Id')" [ngClass]="{'border-red': (!otp3 && OtpForm?.form?.controls?.otp3?.touched)}">
                </app-input>
            </div>
            <div class="col-2">
                <app-input [onlyNumbers]="true" [isOtpInput]="otp4" [isOnPaste]="true" (onPaste)="onPaste($event)" onlyNumbers [inputName]="'opt4'" [inputType]="'text'" [maxLength]="1" [inputId]="'opt4Id'"
                    [inputValue]="otp4" [isRequired]="true" (inputValueEmit)="otp4 = $event"
                    [inputClass]="'text-center'" [focusInputOtp]="true"
                    (keyup)="moveFocusToSecondInput($event,'opt5Id','opt3Id')" [ngClass]="{'border-red': (!otp4 && OtpForm?.form?.controls?.otp4?.touched)}">
                </app-input>
            </div>
            <div class="col-2">
                <app-input [onlyNumbers]="true" [isOtpInput]="otp5" [isOnPaste]="true" (onPaste)="onPaste($event)" onlyNumbers [inputName]="'opt5'" [inputType]="'text'" [inputId]="'opt5Id'"
                    [inputValue]="otp5" [maxLength]="1" [isRequired]="true" [inputClass]="'text-center'"
                    (inputValueEmit)="otp5 = $event" [focusInputOtp]="true"
                    (keyup)="moveFocusToSecondInput($event,'opt6Id','opt4Id')" [ngClass]="{'border-red': (!otp5 && OtpForm?.form?.controls?.otp5?.touched)}">
                </app-input>
            </div>
            <div class="col-2">
                <app-input [onlyNumbers]="true" [isOtpInput]="otp6" [isOnPaste]="true" (onPaste)="onPaste($event)" onlyNumbers [inputName]="'opt6'" [inputType]="'text'" [inputId]="'opt6Id'" [maxLength]="1"
                    [inputValue]="otp6" [isRequired]="true" [inputClass]="'text-center'"
                    (inputValueEmit)="otp6 = $event" [focusInputOtp]="true" [ngClass]="{'border-red': (!otp6 && OtpForm?.form?.controls?.otp6?.touched)}"
                    (keyup)="moveFocusToSecondInput($event,'opt6Id','opt5Id')">
                </app-input>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <span class="text-primary-color f-12 mt-2 text-decoration-underline cursor-pointer" (click)="reSendOtpHandler()">Re-send OTP</span>
        </div>
    </div>
    <div class="col-12 d-flex my-3 justify-content-center">
        <div class="d-flex flex-column">
        <app-button 
            [ngClass]="{'cursor-not-allowed' : !(otp1 && otp2 && otp3 && otp3 && otp4 && otp5 && otp6)}" 
            (click)="verifyOtp()" 
            [disabled]="!(otp1 && otp2 && otp3 && otp3 && otp4 && otp5 && otp6)"
            id="varifyOtP" 
            [customClass]="'Darkprimary px-4'"  
            [buttonLabel]="'Verify'">
        </app-button>
        </div>
    </div>
</form>